import { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles, Crown, Star } from 'lucide-react';
import { getCongratulation } from '@/utils/localization';

export default function VIPSuccessModal({ isOpen, onClose, userName, userGender }) {
  useEffect(() => {
    if (isOpen) {
      // Konfeti animacija
      const duration = 3000;
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      const interval = setInterval(function() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        
        // Konfeti iš kairės
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
          colors: ['#FFD700', '#9333EA', '#1E3A8A', '#F59E0B']
        });
        
        // Konfeti iš dešinės
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
          colors: ['#FFD700', '#9333EA', '#1E3A8A', '#F59E0B']
        });
      }, 250);

      // Fejerverkai centre
      setTimeout(() => {
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { x: 0.5, y: 0.5 },
          colors: ['#FFD700', '#9333EA', '#1E3A8A'],
          zIndex: 9999
        });
      }, 500);

      return () => clearInterval(interval);
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-gradient-to-br from-violet-950 via-indigo-950 to-slate-950 border-2 border-amber-500/50 max-w-md mx-auto">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="relative">
              <Crown className="w-16 h-16 text-amber-400 animate-pulse" />
              <Sparkles className="w-6 h-6 text-amber-300 absolute -top-2 -right-2 animate-bounce" />
              <Star className="w-5 h-5 text-amber-300 absolute -bottom-1 -left-2 animate-bounce" style={{ animationDelay: '0.3s' }} />
            </div>
          </div>
          <DialogTitle className="text-2xl text-center text-amber-400 font-display">
            🎉 {getCongratulation(userName, userGender)}
          </DialogTitle>
        </DialogHeader>
        
        <div className="text-center space-y-4 py-4">
          <p className="text-lg text-foreground/90 leading-relaxed">
            Sveikiname prisijungus prie <span className="text-amber-400 font-bold">NUMENAXIS</span> šeimos!
          </p>
          
          <p className="text-foreground/80 leading-relaxed">
            Tu esi ten, kur renkasi <span className="text-purple-400">sąmoningi žmonės</span>, 
            kuriems svarbu <span className="text-blue-400">augti</span> ir <span className="text-amber-400">pažinti save</span>!
          </p>

          <div className="bg-gradient-to-r from-amber-500/20 to-purple-500/20 rounded-lg p-4 mt-4 border border-amber-500/30">
            <p className="text-sm text-foreground/70">
              Tavo asmeninė „Kelionės knyga" jau ruošiama ir bus išsiųsta į tavo el. paštą!
            </p>
          </div>

          <div className="flex gap-2 pt-4">
            <Button
              onClick={onClose}
              className="flex-1 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-semibold"
            >
              <Sparkles className="w-4 h-4 mr-2" />
              Pradėti kelionę
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
